
<template>
  <div id="id" class="WYSIWYG" ref="WYSIWYG-div" v-html="modifiedContent" v-if="!boagt && !membershipOptions">

  </div>
  <div id="id" class="WYSIWYG" ref="WYSIWYG-div" v-else-if="membershipOptions != false">
    <MembershipOptions :content="this.membershipOptions"/>
  </div>
  <div id="id" class="WYSIWYG" ref="WYSIWYG-div" v-else>
    <Boagt :content="this.boagt"/>
  </div>
</template>

<script>

import Boagt from "./Boagt"
import MembershipOptions from "./MembershipOptionsTable";

// const patt = /\[wholesale.*?\]/gm;
const regex = /(\[member_name.*?\])|(\[[Ww]holesale.*?\])|(\[gold.*?\])|(\[silver.*?\])|(\[loggedin.*?\])|(\[end_gold.*?\])|(\[end_silver.*?\])|(\[end_loggedin.*?\])/gm; //Or with another group you want to search for
const nameRegex = /(\[member_name.*?\])/gm
const wholesaleRegex = /(\[[Ww]holesale.*?\])/gm //make another regex for what you're looking
const goldRegex = /(\[gold.*?\])/gm
const endGoldRegex = /(\[end_gold.*?\])/gm
const silverRegex = /(\[silver.*?\])/gm
const endSilverRegex = /(\[end_silver.*?\])/gm
const loggedinRegex = /(\[loggedin.*?\])/gm
const endLoggedinRegex = /(\[end_loggedin.*?\])/gm
const boagtRegex = /(\[boagt.*?\])/gm
const membershipOptionsRegex = /(\[membershipoptions.*?\])/gm

//Documentation
import { mapGetters, mapState } from 'vuex'

import Popper from 'popper.js'

export default {
  name: "WYSIWYG",
  components:{
    // WholesalePlus
    Boagt,
	MembershipOptions
  },
  props: ["content", "acf_fc_layout"],
  created(){
      this.$store.dispatch("member/getMemberDetails")
      this.showNext = true;
  },
  mounted(){
    // entire view has been rendered
    this.$nextTick(function(){
      this.applyPopper()
      let scroll_id = this.$route.query["scroll_id"]
      if(scroll_id){
        let scroll_item = document.getElementById(scroll_id).parentElement
        scroll_item.scrollIntoView()
        scroll_item.click()
      }
    })
  },
  updated: function(){
    // Code that will run only after the
    // entire view has been rendered
    this.$nextTick(function(){
      this.applyPopper()
    })
  },
  methods:{
    applyPopper(){
      let parentNode = this.$refs["WYSIWYG-div"]
      //do the thing.
      let popup_containers = parentNode.getElementsByClassName("popup-container")
      if(popup_containers.length > 0){
        for(let container of popup_containers) {
          new Popper(container.firstElementChild, container.lastElementChild,{
            placement: 'right',
          })
        }
      }
    }
  },
  computed:{
    ...mapState({
      memberLevel: state => state.auth.memberLevel
    }),
    ...mapGetters({
        memberName: "member/firstName"
    }),
    modifiedContent(){
      //split incoming string on regex, keeping delimiters
      const parts =  this.content.split(regex);
      let silverBlock = false;
      let goldBlock = false
      let loggedinBlock = false;
      let generalShow = true;
      let result = [];
      //console.log(result)
      //iterate through parts and find which matched regex
      parts.forEach(part => {
        if(part != undefined){
          if (part.match(regex)){
            if(part.match(silverRegex)){
              silverBlock = true;
              generalShow = false;
            } else if(part.match(endSilverRegex)){
              silverBlock = false;
              generalShow = true;
            } else if(part.match(goldRegex)){
              goldBlock = true;
              generalShow = false;
            } else if(part.match(endGoldRegex)){
              goldBlock = false;
              generalShow = true;
            } else if(part.match(loggedinRegex)){
              loggedinBlock = true;
              generalShow = false;
            } else if(part.match(endLoggedinRegex)){
              loggedinBlock = false;
              generalShow = true;
            } else if((goldBlock && this.memberLevel == 'gold') || (silverBlock && this.memberLevel == 'silver') || (loggedinBlock && this.memberLevel != "public") || generalShow){
              if(part.match(wholesaleRegex)){ //Wholesale plus
                let word = (part.match(/(\[w)/)) ? "wholesale+" : "Wholesale+"; //Lower or uppercase wholesale
                //replace matched with relevant content
                result.push(`<span class="popup-container"><span class='popup-text wholesalePlusHover'>${word}</span><span class='popup'>Wholesale+ is the price direct from wholesalers and distributors plus a minimal handling fee of 4%-11%. There is no retail margin.</span></span>`)
              } else if (part.match(nameRegex)){
                result.push(this.memberName)
              }
            }
          } else if((goldBlock && this.memberLevel == 'gold') || (silverBlock && this.memberLevel == 'silver') || (loggedinBlock && this.memberLevel != "public") || generalShow){
            result.push(part)
          }
        }
      });
      //join it all together again before displaying it
      return result.join("")
    },
    boagt(){
      if(this.content.match(boagtRegex)){
        return this.content.substring(16)
      }else{
        return false
      }
    },
	membershipOptions() {
		if(this.content.match(membershipOptionsRegex)){
			return this.content.substring(16)
		}else{
			return false
		}
	}
  },

};
</script>

<style lang="scss" scoped>

.WYSIWYG{
	padding-top:20px;
	padding-bottom:20px;
}

@include media-breakpoint-down(md){
	.WYSIWYG{
		padding-top: 0;
		padding-bottom: 0;
	}
}

//apply styles to html inside wysywig
.WYSIWYG::v-deep{
	.popup{
		width:300px;
		font-weight: normal;
		display: inline-block;
		height: auto !important;
		padding:10px;
		border-radius: 10px;
		box-shadow: 0px 2px 10px 1px  darkgrey;
		background: white;
		border:1px solid lightgrey;
		z-index:10;
		opacity: 0;
		transition: opacity .2s ease-in-out;
		font-size: 12pt;
		text-align: left;
	}

	.popup-text{
		border-bottom:1px dashed $CTred;
	}

	.popup-text:hover + .popup{
		opacity: 1;
	}

	#faq-header{
		max-width: 850px;
		margin: 0 auto;
	}

	table{
		border-collapse: collapse;
		thead tr, tr:nth-child(2n){
			background-color: #f6f6f6;
		}
		th, td {
			border: 1px solid #eaeaea;
			max-width: 110px;
			height: 70px;
		}
	}

	.wpcf7-form-control{
		width: 100%;
		max-width: 400px;
	}

	.wholesalePlusHover {
		cursor: default;
	}
	img.borderedImage {
		border: 2px solid $CTgold;
	}
}
</style>
